import { pxToRem, color } from '../../utils'
import Button from './Button'
import React from 'react'
import { RefreshIcon } from '../icons'
import styled from 'styled-components'

const Wrapper = styled(Button)`
  align-items: center;
  background: transparent;
  border-color: ${color.primary};
  color: ${color.primary};
  display: flex;
  font-size: ${pxToRem(12)};
  font-weight: bold;
  justify-content: center;
  padding: ${pxToRem(8)} ${pxToRem(15)};

  svg {
    margin-left: ${pxToRem(10)};
  }
`

const ReloadButton = props => {
  const { ...rest } = props

  return (
    <Wrapper {...rest}>
      Tentar novamente
      <RefreshIcon />
    </Wrapper>
  )
}

export default ReloadButton



// WEBPACK FOOTER //
// ./src/components/Form/ReloadButton.js